import { motion } from 'framer-motion';

const pageMotion = {
  initial: { opacity: 0, y: 22, scale: 0.985 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: 14, scale: 0.992 }
};

export const Page = ({ children, className = '' }) => {
  return (
    <motion.div
      {...pageMotion}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className={`container mx-auto px-4 py-10 ${className}`}
    >
      {children}
    </motion.div>
  );
};
